import React from 'react'
import Logo from './navbar/Logo'
import RedesTopNavbar from './navbar/RedesTopNavbar'
import DatoTopNav from './navbar/DatoTopNav'
import { IoMail } from 'react-icons/io5'
import { BsGeoAltFill } from 'react-icons/bs'
import { Link } from 'react-router-dom'

function Footer() {
    return (
      <>
      <div className='shadow-footshadow flex flex-col pt-10 p-5 w-full xl:h-46 xl:flex-row xl:justify-between'>
          <div className='flex flex-row w-full mb-5 pt-6 xl:w-5/12 xl:h-36 xl:justify-between xl:p-10 btl:pl-10 xl:items-center xl:w-4/12'  >
              <ul className='flex flex-col w-1/2 text-center '>
              <li className='p-2'><Link to='/envios' className='text-bsm font-bold'>Politicas de Envío</Link></li>
              <li className='p-2'><Link to='/devoluciones' className='text-bsm font-bold'>Politicas de Devolución</Link></li>
              <li className='p-2'><Link to='/privacidad' className='text-bsm font-bold'>Politicas de Privacidad</Link></li>
              <li className='p-2'><Link to='/terminos' className='text-bsm font-bold'>Términos y Condiciones</Link></li>
              </ul>
              <ul className='flex flex-col w-1/2 text-center '>
              <li className='p-2'><Link to='/contacto' className='text-bsm font-bold'>Contacto</Link></li>
              <li className='p-2'><Link to='/post-venta' className='text-bsm font-bold'>Post-Venta</Link></li>
              <li className='p-2'><Link to='/marcas' className='text-bsm font-bold'>Marcas</Link></li>
              <li className='p-2'><Link to='sobrenosotros' className='text-bsm font-bold'>Sobre Nosotros</Link></li>
              </ul>
      </div>
          <div className='hidden xl:flex xl:justify-center xl:items-center xl:w-4/12 xl:h-36'>
              <Logo size={'btl:w-80 xl:w-96 '}/>
      </div>
          <div className='flex xl:flex-col xl:justify-center xl:w-5/12 xl:w-4/12 xl:h-36'>
              <div className='w-full flex justify-center'>
                  <div className='w-full p-2 xl:w-4/5 flex flex-col xl:justify-center xl:items-center'>
                            <RedesTopNavbar footer={true} size={22} extraStyle={'flex justify-evenly  w-full xl:w-full xl:h-1/3 xl:justify-around xl:mt-5 xl:mb-5 xl:p-2'} />
                            <div className='p-5'>
                  <DatoTopNav datoBox={"w-full p-1 justify-center"} dataRow={'mr-2 text-GrisOscuro'} item={<IoMail size={20} />} dato={"admin@agroh.info"}/>
                  <DatoTopNav datoBox={"w-full p-1 justify-center"} dataRow={'mr-2 text-GrisOscuro'} item={<BsGeoAltFill size={20} />} dato={"Av.Gobernador del Campo 441, S.M. de Tucumán"}/>
                            </div>
                  </div>
              </div>
          </div>
      </div>
      <div className='btl:hidden flex justify-center items-center w-full h-36'>
              <Logo size={'w-80'}/>
      </div>
  </>
  )
}

export default Footer